// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ShopRouteImport } from './routes/shop'
import { Route as PrimeraDivisionRouteImport } from './routes/primera-division'
import { Route as NewsRouteImport } from './routes/news'
import { Route as NationalTeamRouteImport } from './routes/national-team'
import { Route as LogInRouteImport } from './routes/log-in'
import { Route as ForumRouteImport } from './routes/forum'
import { Route as ContactUsRouteImport } from './routes/contact-us'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AboutUsRouteImport } from './routes/about-us'
import { Route as IndexRouteImport } from './routes/index'
import { Route as NewsSlugRouteImport } from './routes/news_.$slug'
import { Route as NationalTeamIndexRouteImport } from './routes/national-team.index'
import { Route as NationalTeamWorldCupRouteImport } from './routes/national-team.world-cup'
import { Route as NationalTeamWomenRouteImport } from './routes/national-team.women'
import { Route as NationalTeamU20RouteImport } from './routes/national-team.u20'
import { Route as NationalTeamU17RouteImport } from './routes/national-team.u17'
import { Route as NationalTeamU15RouteImport } from './routes/national-team.u15'
import { Route as NationalTeamStatisticsRouteImport } from './routes/national-team.statistics'
import { Route as NationalTeamSquadRouteImport } from './routes/national-team.squad'
import { Route as NationalTeamFixturesRouteImport } from './routes/national-team.fixtures'
import { Route as ForumPollsRouteImport } from './routes/forum.polls'
import { Route as ContactUsPartnershipRouteImport } from './routes/contact-us.partnership'
import { Route as ContactUsJobsRouteImport } from './routes/contact-us.jobs'
import { Route as NationalTeamFixturesIdRouteImport } from './routes/national-team.fixtures_.$id'

const ShopRoute = ShopRouteImport.update({
            id: '/shop',path: '/shop',getParentRoute: () => rootRouteImport
          })
const PrimeraDivisionRoute = PrimeraDivisionRouteImport.update({
            id: '/primera-division',path: '/primera-division',getParentRoute: () => rootRouteImport
          })
const NewsRoute = NewsRouteImport.update({
            id: '/news',path: '/news',getParentRoute: () => rootRouteImport
          })
const NationalTeamRoute = NationalTeamRouteImport.update({
            id: '/national-team',path: '/national-team',getParentRoute: () => rootRouteImport
          })
const LogInRoute = LogInRouteImport.update({
            id: '/log-in',path: '/log-in',getParentRoute: () => rootRouteImport
          })
const ForumRoute = ForumRouteImport.update({
            id: '/forum',path: '/forum',getParentRoute: () => rootRouteImport
          })
const ContactUsRoute = ContactUsRouteImport.update({
            id: '/contact-us',path: '/contact-us',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AboutUsRoute = AboutUsRouteImport.update({
            id: '/about-us',path: '/about-us',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const NewsSlugRoute = NewsSlugRouteImport.update({
            id: '/news_/$slug',path: '/news/$slug',getParentRoute: () => rootRouteImport
          })
const NationalTeamIndexRoute = NationalTeamIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => NationalTeamRoute
          })
const NationalTeamWorldCupRoute = NationalTeamWorldCupRouteImport.update({
            id: '/world-cup',path: '/world-cup',getParentRoute: () => NationalTeamRoute
          })
const NationalTeamWomenRoute = NationalTeamWomenRouteImport.update({
            id: '/women',path: '/women',getParentRoute: () => NationalTeamRoute
          })
const NationalTeamU20Route = NationalTeamU20RouteImport.update({
            id: '/u20',path: '/u20',getParentRoute: () => NationalTeamRoute
          })
const NationalTeamU17Route = NationalTeamU17RouteImport.update({
            id: '/u17',path: '/u17',getParentRoute: () => NationalTeamRoute
          })
const NationalTeamU15Route = NationalTeamU15RouteImport.update({
            id: '/u15',path: '/u15',getParentRoute: () => NationalTeamRoute
          })
const NationalTeamStatisticsRoute = NationalTeamStatisticsRouteImport.update({
            id: '/statistics',path: '/statistics',getParentRoute: () => NationalTeamRoute
          })
const NationalTeamSquadRoute = NationalTeamSquadRouteImport.update({
            id: '/squad',path: '/squad',getParentRoute: () => NationalTeamRoute
          })
const NationalTeamFixturesRoute = NationalTeamFixturesRouteImport.update({
            id: '/fixtures',path: '/fixtures',getParentRoute: () => NationalTeamRoute
          })
const ForumPollsRoute = ForumPollsRouteImport.update({
            id: '/polls',path: '/polls',getParentRoute: () => ForumRoute
          })
const ContactUsPartnershipRoute = ContactUsPartnershipRouteImport.update({
            id: '/partnership',path: '/partnership',getParentRoute: () => ContactUsRoute
          })
const ContactUsJobsRoute = ContactUsJobsRouteImport.update({
            id: '/jobs',path: '/jobs',getParentRoute: () => ContactUsRoute
          })
const NationalTeamFixturesIdRoute = NationalTeamFixturesIdRouteImport.update({
            id: '/fixtures_/$id',path: '/fixtures/$id',getParentRoute: () => NationalTeamRoute
          })





const ContactUsRouteChildren = {
  ContactUsJobsRoute: ContactUsJobsRoute,ContactUsPartnershipRoute: ContactUsPartnershipRoute
}

const ContactUsRouteWithChildren = ContactUsRoute._addFileChildren(ContactUsRouteChildren)




const ForumRouteChildren = {
  ForumPollsRoute: ForumPollsRoute
}

const ForumRouteWithChildren = ForumRoute._addFileChildren(ForumRouteChildren)




const NationalTeamRouteChildren = {
  NationalTeamFixturesRoute: NationalTeamFixturesRoute,NationalTeamSquadRoute: NationalTeamSquadRoute,NationalTeamStatisticsRoute: NationalTeamStatisticsRoute,NationalTeamU15Route: NationalTeamU15Route,NationalTeamU17Route: NationalTeamU17Route,NationalTeamU20Route: NationalTeamU20Route,NationalTeamWomenRoute: NationalTeamWomenRoute,NationalTeamWorldCupRoute: NationalTeamWorldCupRoute,NationalTeamIndexRoute: NationalTeamIndexRoute,NationalTeamFixturesIdRoute: NationalTeamFixturesIdRoute
}

const NationalTeamRouteWithChildren = NationalTeamRoute._addFileChildren(NationalTeamRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutUsRoute: AboutUsRoute,AdminRoute: AdminRoute,ContactUsRoute: ContactUsRouteWithChildren,ForumRoute: ForumRouteWithChildren,LogInRoute: LogInRoute,NationalTeamRoute: NationalTeamRouteWithChildren,NewsRoute: NewsRoute,PrimeraDivisionRoute: PrimeraDivisionRoute,ShopRoute: ShopRoute,NewsSlugRoute: NewsSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)